import { isUndefined } from "util";
import { orderBy } from "lodash";


export class CommonHelper {
    public static SayHello() {
        console.log('Hi')
    }

    public static Exists(object, attr?) {
        if (isUndefined(object) || object == null || object == "Invalid Date") return false;
        if (isUndefined(attr) || attr == null) return true;
        var obj = CommonHelper.ResolveAttr(object, attr);
        return !isUndefined(obj) && obj != null && object != "Invalid Date";
    }

    public static ResolveAttr(obj, attr) {
        if (attr == 0) return;
        var attrs = attr.split(".");
        var index = attr.indexOf(".");
        if (attrs.length == 0) return;
        if (attrs.length == 1) return obj[attrs[0]];
        if (!CommonHelper.Exists(obj[attrs[0]])) return undefined;
        return CommonHelper.ResolveAttr(obj[attrs[0]], attr.substr(index + 1, attr.length - index));
    }
    public static OrderArrayByProperty(arr, columns, order) {
        // sort array by multiple properties with different orders. 
        //orderArrayByProperty(arr,[Column1,Column2],[asc,desc]) is  Equivalent to SQL ORDER BY Column1 ASC, Column2 DESC
        if (arr == null || isUndefined(arr))
            return "";
        else {
            return orderBy(arr, columns, order);
        }
    }

    public static FindDuplicateInArray(arra1) {
        var object = {};
        var result = [];

        arra1.forEach(function (item) {
          if(!object[item])
              object[item] = 0;
            object[item] += 1;
        })

        for (var prop in object) {
           if(object[prop] >= 2) {
               result.push(prop);
           }
        }
        return result;

    }

}